var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 8.494C10.2 8.494 6.60001 12.394 6.60001 14.794C6.59344 15.2733 6.68135 15.7493 6.85871 16.1946C7.03608 16.64 7.29942 17.046 7.63371 17.3896C8.30884 18.0835 9.23197 18.4807 10.2 18.494C11.168 18.5073 12.1017 18.1354 12.7956 17.4603C13.1392 17.126 13.4135 16.7273 13.603 16.287C13.7925 15.8467 13.8934 15.3733 13.9 14.894V14.794C13.9 12.394 10.2 8.494 10.2 8.494ZM8.73001 7.137L9.39901 6.413L7.10001 0H5.10001L0.100006 14H2.10001L3.53001 10H6.47301C7.15169 8.99091 7.90478 8.03392 8.72601 7.137H8.73001ZM6.10001 2.8L7.96001 8H4.24401L6.10001 2.8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColor);
export default __webpack_public_path__ + "static/media/edit_color.46a0320cc98f2524b05e1754c3c4759a.svg";
export { ForwardRef as ReactComponent };